import { render, staticRenderFns } from "./PressReleaseCreate.vue?vue&type=template&id=3e742be5&scoped=true"
import script from "./PressReleaseCreate.vue?vue&type=script&lang=js"
export * from "./PressReleaseCreate.vue?vue&type=script&lang=js"
import style0 from "./PressReleaseCreate.vue?vue&type=style&index=0&id=3e742be5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e742be5",
  null
  
)

export default component.exports